import type { FaireProductEntity } from "../../entity_types/product";

export const p_mzv7ftuqqm: FaireProductEntity = {
  token: "p_mzv7ftuqqm",
  type: "product",
  name: "Open-Front Checked Cardigan",
  brandToken: "b_ysnwrcjujg",
  brandName: "Mccolin",
  imageUrl:
    "https://cdn.faire.com/fastly/326d164f42c57f52c31a87e3b7399044a0b8a6274aa644f6d52751ab844fba46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de64acc4eec552168a2c3d90f2cd3885c9bde895b1a891cebb6df55bdc606971.jpeg",
    "https://cdn.faire.com/fastly/7f793a7a527635204352315a53c65ab6d30e777575a63a5a2f63314895c431f2.jpeg",
    "https://cdn.faire.com/fastly/8331120e2aeebb022fe24e8fa9bd2b3b05e8aa97c2f877efbac0f930ebe736e2.jpeg",
    "https://cdn.faire.com/fastly/3ffa2fa0b6335531136e7ec8f50d35b721484a536f7849ecd74f6f2dc0480661.jpeg",
    "https://cdn.faire.com/fastly/d124c0743611209f9e6a4dbd7acdb78c30ebb58af1df402854e04c0f7320becc.jpeg",
    "https://cdn.faire.com/fastly/3c664fa3bdc800086ce7acdd102399282b0e37cc576657f74d654acda6073bfb.jpeg",
    "https://cdn.faire.com/fastly/8e73046094427e1d3bd35550127f5f68e03cfe26a8e66e628c3858dc51172833.jpeg",
  ],
  priceDollars: 27.68,
  description:
    "Your new favorite cardigan features an open-front design with relaxed sleeves for effortless layering. Perfect for casual outfits and transitional weather.\n\nFabric: 100% polyester\n\nWeight: 1.65 lb\n",
  tags: [],
  msrpDollars: 55.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:20.331Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
